import config from 'js/app/config';

export const BANNER_MOCKS = {
  CAPITAL_ONE: {
    logoImage: `${config.url.resource_assets}teams_v2/spring_primary.png`,
    description: 'CapitalOne Discount',
  },
  MASTERCARD: {
    logoImage: `${config.url.resource_assets}teams_v2/mc_symbol_opt_73_3x.png`,
    description: 'Mastercard Discount',
  },
  VISA: {
    logoImage: `${config.url.resource_assets}teams_v2/visa.jpg`,
    description: 'Visa Discount',
  },
  CART_ABANDONMENT: {
    description: 'Coursera Promotion',
  },
};
